let ws = null
let pingTimer = null
let reconnectTimer = null

let manualClose = false
let reconnectCount = 0

const MAX_RECONNECT = 3
const RECONNECT_DELAY = 2000
const PING_INTERVAL = 20000

let store = null
let lastParams = null

function clear() {
  pingTimer && clearInterval(pingTimer)
  pingTimer = null

  reconnectTimer && clearTimeout(reconnectTimer)
  reconnectTimer = null

  if (ws) {
    ws.close()
    ws = null
  }
}

function reconnect() {
  if (manualClose) return
  if (reconnectCount >= MAX_RECONNECT) return
  if (reconnectTimer) return   // 防止多次重连定时器

  reconnectCount++

  reconnectTimer = setTimeout(() => {
    reconnectTimer = null
    connect(lastParams)
  }, RECONNECT_DELAY)
}


function connect(params) {
	if (ws) return
	if (!store) {
		console.error('[kefuSocket] store 未注入')
		return
	}

	manualClose = false
	lastParams = params

	const {
		wsUri,
		token,
		expire_time,
		customer_service_id,
		channel_key
	} = params

	const url =
		wsUri +
		'?identify=customer_service' +
		'&token=' + token +
		'&expire_time=' + expire_time +
		'&customer_service_id=' + customer_service_id +
		'&channel_key=' + channel_key
		// '&channel_key=sadfdsaf12as1f'

	ws = new WebSocket(url)

	ws.onopen = () => {
		reconnectCount = 0
		store.commit('kefu/SET_LINE_STATUS', 'online')

		pingTimer = setInterval(() => {
			if (ws && ws.readyState === WebSocket.OPEN) {
				ws.send(JSON.stringify({
					type: 'ping'
				}))
			}
		}, PING_INTERVAL)
	}

	ws.onmessage = evt => {
		try {
			const result = JSON.parse(evt.data)
			store.dispatch('kefu/handleSocketMessage', result)
		} catch (e) {
			console.error('[kefuSocket] message parse error', e)
		}
	}

	ws.onerror = err => {
		console.error('[kefuSocket] error', err)
	}

	ws.onclose = () => {
		store.commit('kefu/SET_LINE_STATUS', 'offline')
		clear()
		reconnect()
	}
}

function destroy() {
	manualClose = true
	clear()
}

function send(data) {
	if (!ws || ws.readyState !== WebSocket.OPEN) return false
	ws.send(JSON.stringify(data))
	return true
}

function init(options) {
	store = options.store
}

export default {
	init,
	connect,
	send,
	destroy
}